Vendd.Scripts.load(function () {

	Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-availability-notification', function (envelope) {

        var $context = envelope.message.data.context,
            $form = $('.x-product-details-availability-notification', $context);

        if ($form.length < 1)
            return;

        $form.each(function () {

            var form = $(this),
                $formButton = $('.js-submit', form),              
                formData = { email: "" };

            form.loading = function (loading) {
                if (loading) {
                    form.addClass('x-loading');
                } else {
                    form.removeClass('x-loading');
                };
            };

            form.onSuccess = function (envelope) {
                var response = envelope.message.data;
                var sender = envelope.message.data.sender;
                if (form && sender && form == sender) {
                    form.loading(false);

                    if (response.success) {
                        $('.js-error', form).hide();
                        $('.js-success', form).show();

                        $('.js-content', form).hide();
                    } else {
                        $('.js-error', form).show();
                    };
                }
            };

            form.onFailure = function (envelope) {
                var response = envelope.message.data;
                var sender = envelope.message.data.sender;
                if (form && sender && form == sender) {
                    form.loading(false);

                    $('.js-error', form).show();
                }
            };

            form.submit = function () {
                form.loading(true);
                var selectedId, state = Vendd.Product.Controller.getState();

                if (form.closest('.x-product-variant-box').length > 0) {
                    selectedId = form.closest('.x-product-variant-box').attr('data-variantid');
                } else {
                    selectedId = state.selectedId;
                }

                Vendd.MessageBus.publishAsync(form, new Vendd.Product.Messages.Notify(formData.email, selectedId, state.languageId));
            };

            form.reset = function () {
                $('.js-error', form).hide();
                $('.js-success', form).hide();

                $('input[name="email"]', form).val("");

                $('.js-content', form).hide();

                rnf.reset();
            };

            form.validationEngine({
                email: {
                    required: 'email-required',
                    isEmail: 'email-invalid'
                }
            });
            var rnf = form.data('validationEngine');

            form.on('click', '.js-submit', function (e) {
                e.preventDefault();
                e.stopPropagation();

                formData.email = $('input[name="email"]', form).val();

                if (rnf.validate())
                    form.submit();
            });

            form.on('keyup', 'input[name]', function (e) {
                var $this = $(this);

                if (e.keyCode == 13) {
                    e.preventDefault();
                    e.stopPropagation();

                    $formButton.click();

                    return;
                }

                formData[$this.attr('name')] = $this.val();

                rnf.validate($this.attr('name'));
            });

            Vendd.MessageBus.unsubscribe(Vendd.Product.Messages.NotifySuccess, form);
            Vendd.MessageBus.unsubscribe(Vendd.Product.Messages.NotifyFailure, form);

            Vendd.MessageBus.subscribe(Vendd.Product.Messages.NotifySuccess, form, form.onSuccess);
            Vendd.MessageBus.subscribe(Vendd.Product.Messages.NotifyFailure, form, form.onFailure);
        });
    });

});